module.exports = __webpack_public_path__ + "img/Still-Thinking-4.4ee2c4a8.png";